import React, { createContext, useRef, useContext } from 'react';
import { Toast } from 'primereact/toast';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const toast = useRef(null);

    // Función simplificada para invocar el toast
    const showToast = (severity, summary, detail, life = 3000) => {
        toast.current?.show({ severity, summary, detail, life });
    };

    // Accesos directos
    const showError = (detail, summary = 'Error') => showToast('error', summary, detail);
    const showSuccess = (detail, summary = 'Éxito') => showToast('success', summary, detail);

    return (
        <ToastContext.Provider value={{ showToast, showError, showSuccess, toast }}>
            <Toast ref={toast} />
            {children}
        </ToastContext.Provider>
    );
};

// Hook personalizado para usarlo fácilmente
export const useGlobalToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error("useGlobalToast debe ser usado dentro de un ToastProvider");
    }
    return context;
};